import React from 'react';
import PropTypes from 'prop-types';
import BasePlayerReport from './BasePlayerReport';

const OpposingPitcherReport = ({ match: { path, url, params: { pitcherId } }, location: { pathname }, tabs }) => (
    <>
        <BasePlayerReport tabs={tabs} pathname={pathname} path={path} url={url} playerId={pitcherId} />
    </>
);

OpposingPitcherReport.propTypes = {
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    match: PropTypes.shape({
        path: PropTypes.string.isRequired,
        url: PropTypes.string.isRequired,
        params: PropTypes.shape({
            pitcherId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        }).isRequired,
    }).isRequired,
    team: PropTypes.shape({
        LevelID: PropTypes.number,
        Level: PropTypes.shape({
            LevelID: PropTypes.number,
        }),
    }),
    tabs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

OpposingPitcherReport.defaultProps = {
    team: undefined,
};

export default OpposingPitcherReport;
